/*
 * WorkAndBuhin.vue の日整連・純正部品検索後の表示状態、キャッシュ、選択反映を切り出した処理。
 */
import { BuhinDetail } from "@/model/Buhin";
import { KatashikiParams } from "@/model/KatashikiParams";
import { Work } from "@/model/Work";
import {
  findJunseiBuhinIndex,
  isJunseiBuhinCode
} from "@/components/work-buhin/WorkBuhinMatch";

export interface JunseiTabState {
  activeBuhinCateIndex: number;
  activeCateBuhins: any[];
  activeBuhinShubetsuId: number;
  buhinContent: any[];
  listManualBuhinFiltered: BuhinDetail[];
  autoSelectBuhin: BuhinDetail | null;
}

export interface JunseiTabApplyEffectState {
  activeBuhinCateIndex: number;
  activeCateBuhins: any[];
  activeBuhinShubetsuId: number;
  buhinContent: any[];
  listManualBuhinFiltered: BuhinDetail[];
  shouldApplyBuhinContent: boolean;
  shouldApplyManualBuhinFiltered: boolean;
  shouldAutoSelectBuhin: boolean;
  autoSelectBuhin: BuhinDetail | null;
}

export interface ManualWorkSelectionState {
  isManualWork: boolean;
  activeWorkIndex: number;
  activeSeibiId: number | null;
  activeSeibiNm: string;
  work: Work;
}

export interface NisseirenJunseiSelectedActionState {
  shouldSelectManualWork: boolean;
  manualWorkSelectionState: ManualWorkSelectionState | null;
  shouldUseJunseiBuhin: boolean;
  shouldSetFoundJunseiBuhin: boolean;
  shouldApplySelectedJunseiBuhin: boolean;
  shouldSelectJunseiTab: boolean;
}

export interface NisseirenJunseiSelectedApplyEffectState {
  shouldSetFoundNisseirenWork: boolean;
  foundNisseirenWork: any[];
  shouldSelectManualWork: boolean;
  manualWorkSelectionState: ManualWorkSelectionState | null;
  shouldScrollManualWork: boolean;
  manualWorkScrollTargetId: string;
  shouldUseJunseiBuhin: boolean;
  shouldSetFoundJunseiBuhin: boolean;
  foundJunseiBuhin: any[];
  shouldApplySelectedJunseiBuhin: boolean;
  shouldSetWorkBuhinSelectedDone: boolean;
  shouldSetIsChange: boolean;
  isChange: boolean;
  shouldAppendSelectedJunseiBuhin: boolean;
  selectedJunseiBuhinToAppend: any[];
  shouldScrollJunseiBuhin: boolean;
  junseiBuhinScrollTargetId: string;
  shouldCheckDisabledBtnConfirm: boolean;
  shouldSelectJunseiTab: boolean;
}

export interface FoundNisseirenWorkState {
  shouldApply: boolean;
  manualSeibiList: Work[];
}

export interface FoundNisseirenWorkApplyEffectState {
  shouldApply: boolean;
  manualSeibiList: Work[];
}

export interface NisseirenJunseiCachedSearchState {
  nisseirenWork: any;
  junseiBuhin: any;
  shouldRequestNisseirenWork: boolean;
  shouldRequestJunseiBuhin: boolean;
}

export interface NisseirenJunseiLoadStartApplyEffectState {
  shouldLoadNisseirenJunsei: boolean;
  shouldSetLoading: boolean;
  loading: boolean;
}

export interface NisseirenWorkStoreApplyEffectState {
  shouldSetStore: boolean;
  storePayload: any;
}

export interface JunseiBuhinStoreApplyEffectState {
  shouldSetStore: boolean;
  storePayload: any;
}

export interface NisseirenJunseiLoadedApplyActionState {
  shouldApplyNisseirenWork: boolean;
  shouldApplyJunseiBuhin: boolean;
  shouldSelectJunseiTab: boolean;
  nisseirenWork: any;
  junseiBuhin: any[];
}

export interface NisseirenJunseiLoadedApplyEffectState {
  shouldApplyNisseirenWork: boolean;
  shouldScrollNisseirenWork: boolean;
  nisseirenWorkScrollTargetId: string;
  shouldApplyJunseiBuhin: boolean;
  shouldScrollJunseiBuhin: boolean;
  junseiBuhinScrollTargetId: string;
  shouldSelectJunseiTab: boolean;
  shouldSetLoading: boolean;
  loading: boolean;
  nisseirenWork: any;
  junseiBuhin: any[];
}

export interface JunseiBuhinByNisseirenWorkParams {
  sknNisseirenCd: any;
}

export interface JunseiBuhinByNisseirenWorkApplyActionState {
  shouldApplyJunseiBuhin: boolean;
  junseiBuhin: any[];
}

export interface JunseiBuhinByNisseirenWorkApplyEffectState {
  shouldApplyJunseiBuhin: boolean;
  shouldScrollJunseiBuhin: boolean;
  junseiBuhinScrollTargetId: string;
  junseiBuhin: any[];
}

export interface JunseiBuhinByNisseirenWorkAfterApplyEffectState {
  shouldSetLoading: boolean;
  loading: boolean;
  shouldSelectJunseiTab: boolean;
}

export interface KatashikiDialogOpenParams {
  katashiki: string;
  engineKatashiki: string;
}

export interface KatashikiDialogOpenActionState {
  shouldOpen: boolean;
  katashiki: string;
  engineKatashiki: string;
}

export interface KatashikiDialogOpenApplyEffectState {
  shouldOpen: boolean;
  katashiki: string;
  engineKatashiki: string;
}

export interface NisseirenJunseiSearchDialogOpenActionState {
  shouldOpen: boolean;
  isJunseiOnly: boolean;
  isUseJunseiBuhin: boolean;
}

export interface NisseirenJunseiSearchDialogOpenApplyEffectState {
  shouldOpen: boolean;
  isJunseiOnly: boolean;
  isUseJunseiBuhin: boolean;
}

export interface KatashikiSearchInitialActionState {
  shouldRequestKatashikiList: boolean;
  shouldOpenDialog: boolean;
  dialogKatashiki: string;
  dialogEngineKatashiki: string;
}

export interface KatashikiSearchInitialApplyEffectState {
  shouldRequestKatashikiList: boolean;
  shouldOpenDialogOnNextTick: boolean;
  dialogKatashiki: string;
  dialogEngineKatashiki: string;
}

export interface KatashikiSearchResultActionState {
  shouldSetKatashikiParams: boolean;
  katashikiParamsSource: any;
  shouldOpenDialog: boolean;
  dialogKatashiki: string;
  dialogEngineKatashiki: string;
  dialogData: any[];
}

export interface KatashikiSearchResultApplyEffectState {
  shouldSetKatashikiParams: boolean;
  katashikiParamsSource: any;
  shouldOpenDialog: boolean;
  dialogKatashiki: string;
  dialogEngineKatashiki: string;
  dialogData: any[];
}

export interface KatashikiParamsApplyState {
  katashikiParams: KatashikiParams;
  hasKatashiki: boolean;
  shouldSetKatashikiParams: boolean;
  shouldUpdateDisplayFields: boolean;
  shouldUpdateKatashiki: boolean;
}

export interface KatashikiParamsApplyEffectState {
  katashikiParams: KatashikiParams;
  hasKatashiki: boolean;
  shouldSetKatashikiParams: boolean;
  shouldUpdateDisplayFields: boolean;
  shouldUpdateKatashiki: boolean;
}

export interface KatashikiSelectedActionState {
  shouldSetKatashikiParams: boolean;
  katashikiParamsSource: any;
  shouldLoadNisseirenJunsei: boolean;
}

export interface KatashikiSelectedApplyEffectState {
  shouldSetKatashikiParams: boolean;
  katashikiParamsSource: any;
  shouldLoadNisseirenJunsei: boolean;
}

/*
 * hasCachedKatashikiForUketsuke を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function hasCachedKatashikiForUketsuke(
  katashikiParams: Partial<KatashikiParams>,
  uketsukeExtendsId: number
): boolean {
  return !!(
    katashikiParams.uketsukeExtendsId &&
    katashikiParams.uketsukeExtendsId === uketsukeExtendsId
  );
}

/*
 * shouldLoadNisseirenJunsei を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function shouldLoadNisseirenJunsei(params: {
  data: any;
  isUseNisseiren: number;
  katashikiParams: Partial<KatashikiParams>;
}): boolean {
  return !!(
    params.data &&
    params.data.sknInspectDescriptionId &&
    params.isUseNisseiren &&
    params.katashikiParams.nisseirenKatashiki &&
    params.katashikiParams.nisseirenEngineKatashiki &&
    params.katashikiParams.kakyukiKbn
  );
}

/*
 * getNisseirenWorkStoreKey を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function getNisseirenWorkStoreKey(
  katashikiParams: Partial<KatashikiParams>,
  uketsukeExtendsId: number,
  sknInspectDescriptionId: number
): any[] {
  return [
    katashikiParams.nisseirenKatashiki,
    katashikiParams.nisseirenEngineKatashiki,
    katashikiParams.kakyukiKbn,
    uketsukeExtendsId,
    sknInspectDescriptionId
  ];
}

/*
 * getJunseiBuhinStoreKey を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function getJunseiBuhinStoreKey(
  katashikiParams: Partial<KatashikiParams>,
  sknInspectDescriptionId: number
): any[] {
  return [
    katashikiParams.katashikiShiteiNo,
    katashikiParams.ruibetsuKubunNo,
    katashikiParams.junseiKatashiki,
    katashikiParams.junseiEngineKatashiki,
    katashikiParams.syaryouShiki,
    katashikiParams.syaryouShuki,
    sknInspectDescriptionId
  ];
}

/*
 * buildNisseirenWorkStorePayload を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function buildNisseirenWorkStorePayload(params: {
  katashikiParams: Partial<KatashikiParams>;
  uketsukeExtendsId: number;
  sknInspectDescriptionId: number;
  nisseirenWork: any;
}): any {
  return {
    katashiki: params.katashikiParams.nisseirenKatashiki,
    engineKatashiki: params.katashikiParams.nisseirenEngineKatashiki,
    kakyukiKbn: params.katashikiParams.kakyukiKbn,
    uketsukeExtendsId: params.uketsukeExtendsId,
    sknInspectDescriptionId: params.sknInspectDescriptionId,
    nisseirenWork: params.nisseirenWork
  };
}

/*
 * buildJunseiBuhinStorePayload を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function buildJunseiBuhinStorePayload(params: {
  katashikiParams: Partial<KatashikiParams>;
  sknInspectDescriptionId: number;
  junseiBuhin: any;
}): any {
  return {
    katashikiShiteiNo: params.katashikiParams.katashikiShiteiNo,
    ruibetsuKubunNo: params.katashikiParams.ruibetsuKubunNo,
    katashiki: params.katashikiParams.junseiKatashiki,
    engineKatashiki: params.katashikiParams.junseiEngineKatashiki,
    syaryouShiki: params.katashikiParams.syaryouShiki,
    syaryouShuki: params.katashikiParams.syaryouShuki,
    sknInspectDescriptionId: params.sknInspectDescriptionId,
    junseiBuhin: params.junseiBuhin
  };
}

/*
 * buildNisseirenJunseiCachedSearchState を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function buildNisseirenJunseiCachedSearchState(params: {
  cachedNisseirenWork: any;
  cachedJunseiBuhin: any;
  isUseJunseiBuhin: boolean;
}): NisseirenJunseiCachedSearchState {
  return {
    nisseirenWork: params.cachedNisseirenWork,
    junseiBuhin: params.cachedJunseiBuhin,
    shouldRequestNisseirenWork: !params.cachedNisseirenWork,
    shouldRequestJunseiBuhin: params.isUseJunseiBuhin && !params.cachedJunseiBuhin
  };
}

/*
 * buildNisseirenJunseiLoadStartApplyEffectState を WorkAndBuhin.vue から分離し、
 * 型式条件を満たす場合だけ loading を開始する副作用条件を固定するため。
 */
export function buildNisseirenJunseiLoadStartApplyEffectState(
  canLoadNisseirenJunsei: boolean
): NisseirenJunseiLoadStartApplyEffectState {
  return {
    shouldLoadNisseirenJunsei: canLoadNisseirenJunsei,
    shouldSetLoading: canLoadNisseirenJunsei,
    loading: true
  };
}

/*
 * buildNisseirenWorkStoreApplyEffectState を WorkAndBuhin.vue から分離し、
 * 日整連作業を API 取得した場合だけ cache store へ反映する payload を固定するため。
 */
export function buildNisseirenWorkStoreApplyEffectState(params: {
  shouldRequestNisseirenWork: boolean;
  katashikiParams: Partial<KatashikiParams>;
  uketsukeExtendsId: number;
  sknInspectDescriptionId: number;
  nisseirenWork: any;
}): NisseirenWorkStoreApplyEffectState {
  return {
    shouldSetStore: params.shouldRequestNisseirenWork,
    storePayload: params.shouldRequestNisseirenWork
      ? buildNisseirenWorkStorePayload(params)
      : null
  };
}

/*
 * buildJunseiBuhinStoreApplyEffectState を WorkAndBuhin.vue から分離し、
 * 純正部品を API 取得した場合だけ cache store へ反映する payload を固定するため。
 */
export function buildJunseiBuhinStoreApplyEffectState(params: {
  shouldRequestJunseiBuhin: boolean;
  katashikiParams: Partial<KatashikiParams>;
  sknInspectDescriptionId: number;
  junseiBuhin: any;
}): JunseiBuhinStoreApplyEffectState {
  return {
    shouldSetStore: params.shouldRequestJunseiBuhin,
    storePayload: params.shouldRequestJunseiBuhin
      ? buildJunseiBuhinStorePayload(params)
      : null
  };
}

/*
 * normalizeJunseiBuhinSearchResult を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function normalizeJunseiBuhinSearchResult(items: any[] | null | undefined): any[] {
  return (items || []).map((item: any) => ({
    ...item,
    quantityStep: 0
  }));
}

/*
 * hasJunseiBuhinInManualList を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function hasJunseiBuhinInManualList(manualBuhinList: BuhinDetail[]): boolean {
  return manualBuhinList.findIndex(
    (manualBuhin: BuhinDetail) => isJunseiBuhinCode(manualBuhin.buhinCd)
  ) > -1;
}

/*
 * shouldApplyLoadedNisseirenWork を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function shouldApplyLoadedNisseirenWork(nisseirenWork: any): boolean {
  return !!(nisseirenWork && nisseirenWork.length > 0);
}

/*
 * shouldApplyLoadedJunseiBuhin を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function shouldApplyLoadedJunseiBuhin(
  isUseJunseiBuhin: boolean,
  junseiBuhin: any
): boolean {
  return !!(isUseJunseiBuhin && junseiBuhin && junseiBuhin.length > 0);
}

/*
 * shouldSelectJunseiTabAfterNisseirenLoad を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function shouldSelectJunseiTabAfterNisseirenLoad(
  isUseJunseiBuhin: boolean,
  manualBuhinList: BuhinDetail[]
): boolean {
  return !!(isUseJunseiBuhin && hasJunseiBuhinInManualList(manualBuhinList));
}

/*
 * buildNisseirenJunseiLoadedApplyActionState を WorkAndBuhin.vue から分離し、
 * 型式検索後に取得済みの日整連作業・純正部品を画面へ反映する条件を固定するため。
 */
export function buildNisseirenJunseiLoadedApplyActionState(params: {
  isUseJunseiBuhin: boolean;
  listManualBuhin: BuhinDetail[];
  nisseirenWork: any;
  junseiBuhin: any;
}): NisseirenJunseiLoadedApplyActionState {
  const shouldApplyJunseiBuhin = shouldApplyLoadedJunseiBuhin(
    params.isUseJunseiBuhin,
    params.junseiBuhin
  );
  return {
    shouldApplyNisseirenWork: shouldApplyLoadedNisseirenWork(params.nisseirenWork),
    shouldApplyJunseiBuhin,
    shouldSelectJunseiTab: shouldSelectJunseiTabAfterNisseirenLoad(
      params.isUseJunseiBuhin,
      params.listManualBuhin
    ),
    nisseirenWork: params.nisseirenWork,
    junseiBuhin: shouldApplyJunseiBuhin
      ? normalizeJunseiBuhinSearchResult(params.junseiBuhin)
      : []
  };
}

/*
 * buildNisseirenJunseiLoadedApplyEffectState を WorkAndBuhin.vue から分離し、
 * 日整連・純正検索完了後の画面反映、scroll、loading 終了の副作用条件を固定するため。
 */
export function buildNisseirenJunseiLoadedApplyEffectState(
  actionState: NisseirenJunseiLoadedApplyActionState
): NisseirenJunseiLoadedApplyEffectState {
  return {
    shouldApplyNisseirenWork: actionState.shouldApplyNisseirenWork,
    shouldScrollNisseirenWork: actionState.shouldApplyNisseirenWork,
    nisseirenWorkScrollTargetId: "list-work",
    shouldApplyJunseiBuhin: actionState.shouldApplyJunseiBuhin,
    shouldScrollJunseiBuhin: actionState.shouldApplyJunseiBuhin,
    junseiBuhinScrollTargetId: "list-buhin",
    shouldSelectJunseiTab: actionState.shouldSelectJunseiTab,
    shouldSetLoading: true,
    loading: false,
    nisseirenWork: actionState.nisseirenWork,
    junseiBuhin: actionState.junseiBuhin
  };
}

/*
 * createNisseirenWork を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function createNisseirenWork(item: any): Work {
  return {
    seibiNm: item.seibiNm,
    seibiDetailId: null,
    seibiId: null,
    buhinSelected: 0,
    kousuu: item.kousuu || 0,
    manualBuhinList: [],
    buhinList: [],
    editMode: false,
    sknRecommendInspectCategoryId: null,
    kouchinZn: item.kouchinZn,
    manualExtendsKbn: 1,
    sknNisseirenCd: item.sknNisseirenCd
  } as any;
}

/*
 * appendUniqueNisseirenWork を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function appendUniqueNisseirenWork(
  manualSeibiList: Work[] | null | undefined,
  items: any[]
): Work[] {
  let list = manualSeibiList || [];
  if (items.length > 0) {
    items.forEach((item: any) => {
      const nisseirenWork = createNisseirenWork(item);
      if (list.length === 0) {
        list = [nisseirenWork];
      } else {
        const index = list.findIndex(
          (manualSeibi: any) => manualSeibi.sknNisseirenCd === nisseirenWork.sknNisseirenCd
        );
        if (index === -1) {
          list.push(nisseirenWork);
        }
      }
    });
  }
  return list;
}

/*
 * buildFoundNisseirenWorkState を WorkAndBuhin.vue から分離し、
 * 日整連作業検索結果を手入力作業 list へ反映する条件と反映後 state を親側置換や単体テストで固定するため。
 */
export function buildFoundNisseirenWorkState(params: {
  manualSeibiList: Work[] | null | undefined;
  items: any[];
}): FoundNisseirenWorkState {
  const beforeLength = params.manualSeibiList ? params.manualSeibiList.length : 0;
  const beforeList = params.manualSeibiList;
  const manualSeibiList = appendUniqueNisseirenWork(
    params.manualSeibiList,
    params.items
  );
  return {
    shouldApply: manualSeibiList !== beforeList || manualSeibiList.length !== beforeLength,
    manualSeibiList
  };
}

/*
 * buildFoundNisseirenWorkApplyEffectState を WorkAndBuhin.vue から分離し、
 * 日整連作業検索結果を data.manualSeibiList へ反映する条件と値を固定するため。
 */
export function buildFoundNisseirenWorkApplyEffectState(
  foundState: FoundNisseirenWorkState
): FoundNisseirenWorkApplyEffectState {
  return {
    shouldApply: foundState.shouldApply,
    manualSeibiList: foundState.manualSeibiList
  };
}

/*
 * buildJunseiBuhinByNisseirenWorkParams を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function buildJunseiBuhinByNisseirenWorkParams(
  katashikiParams: Partial<KatashikiParams>,
  sknNisseirenCd: any
): JunseiBuhinByNisseirenWorkParams {
  return {
    sknNisseirenCd
  };
}

/*
 * buildJunseiBuhinByNisseirenWorkApplyActionState を WorkAndBuhin.vue から分離し、
 * 日整連作業に紐づく純正部品検索結果の反映条件と正規化を単体テストで固定するため。
 */
export function buildJunseiBuhinByNisseirenWorkApplyActionState(result: any):
  JunseiBuhinByNisseirenWorkApplyActionState {
  if (!result || !result.found) {
    return {
      shouldApplyJunseiBuhin: false,
      junseiBuhin: []
    };
  }
  return {
    shouldApplyJunseiBuhin: true,
    junseiBuhin: normalizeJunseiBuhinSearchResult(result.result)
  };
}

/*
 * buildJunseiBuhinByNisseirenWorkApplyEffectState を WorkAndBuhin.vue から分離し、
 * 日整連作業別の純正部品検索結果を画面へ反映し scroll する条件を固定するため。
 */
export function buildJunseiBuhinByNisseirenWorkApplyEffectState(
  actionState: JunseiBuhinByNisseirenWorkApplyActionState
): JunseiBuhinByNisseirenWorkApplyEffectState {
  return {
    shouldApplyJunseiBuhin: actionState.shouldApplyJunseiBuhin,
    shouldScrollJunseiBuhin: actionState.shouldApplyJunseiBuhin,
    junseiBuhinScrollTargetId: "list-buhin",
    junseiBuhin: actionState.junseiBuhin
  };
}

/*
 * buildJunseiBuhinByNisseirenWorkAfterApplyEffectState を WorkAndBuhin.vue から分離し、
 * 日整連作業別の純正部品検索完了後に loading を閉じ純正部品タブを選択する条件を固定するため。
 */
export function buildJunseiBuhinByNisseirenWorkAfterApplyEffectState():
  JunseiBuhinByNisseirenWorkAfterApplyEffectState {
  return {
    shouldSetLoading: true,
    loading: false,
    shouldSelectJunseiTab: true
  };
}

/*
 * buildKatashikiParams を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function buildKatashikiParams(
  nisseirenKatashiki: any,
  junseiKatashiki: any,
  searchKatashikiOrUketsukeExtendsId: string | number,
  searchEngineKatashiki: string = "",
  uketsukeExtendsId?: number
): KatashikiParams {
  const isLegacyCall = typeof searchKatashikiOrUketsukeExtendsId !== "string";
  const searchKatashiki = isLegacyCall
    ? ""
    : searchKatashikiOrUketsukeExtendsId as string;
  const resolvedUketsukeExtendsId = isLegacyCall
    ? typeof searchKatashikiOrUketsukeExtendsId === "number"
      ? searchKatashikiOrUketsukeExtendsId
      : uketsukeExtendsId as number
    : uketsukeExtendsId as number;
  const katashikiParams: any = {
    uketsukeExtendsId: resolvedUketsukeExtendsId,
    makerCd: nisseirenKatashiki.makerCd,
    makerNm: nisseirenKatashiki.makerNm,
    modelCd: nisseirenKatashiki.modelCd,
    modelNm: nisseirenKatashiki.modelNm,
    nisseirenKatashiki: nisseirenKatashiki.katashiki,
    nisseirenEngineKatashiki: nisseirenKatashiki.engineKatashiki,
    kakyuki: nisseirenKatashiki.kakyuki,
    kakyukiKbn: nisseirenKatashiki.kakyukiKbn,
    katashikiShiteiNo: junseiKatashiki.katashikiShiteiNo,
    ruibetsuKubunNo: junseiKatashiki.ruibetsuKubunNo,
    junseiKatashiki: junseiKatashiki.katashiki,
    junseiEngineKatashiki: junseiKatashiki.engineKatashiki,
    syaryouShiki: junseiKatashiki.syaryouShiki,
    syaryouShuki: junseiKatashiki.syaryouShuki
  };
  if (!isLegacyCall) {
    katashikiParams.searchKatashiki = searchKatashiki;
    katashikiParams.searchEngineKatashiki = searchEngineKatashiki;
  }
  return katashikiParams;
}

/*
 * buildKatashikiParamsFromSaved を WorkAndBuhin.vue から分離し、
 * 保存済み型式の画面反映前に必要なパラメータ生成を単体テストで固定するため。
 */
export function buildKatashikiParamsFromSaved(
  data: any,
  uketsukeExtendsId: number
): KatashikiParams {
  const katashikiParams: any = {
    uketsukeExtendsId,
    modelCd: data.modelCd,
    nisseirenKatashiki: data.nisseirenKatashiki,
    nisseirenEngineKatashiki: data.nisseirenEngineKatashiki,
    kakyuki: data.kakyuki,
    kakyukiKbn: data.kakyukiKbn,
    katashikiShiteiNo: data.katashikiShiteiNo,
    ruibetsuKubunNo: data.ruibetsuKubunNo,
    junseiKatashiki: data.junseiKatashiki,
    junseiEngineKatashiki: data.junseiEngineKatashiki,
    syaryouShiki: data.syaryouShiki,
    syaryouShuki: data.syaryouShuki
  };
  if (data.searchKatashiki !== undefined) {
    katashikiParams.searchKatashiki = data.searchKatashiki;
  }
  if (data.searchEngineKatashiki !== undefined) {
    katashikiParams.searchEngineKatashiki = data.searchEngineKatashiki;
  }
  return katashikiParams;
}

/*
 * buildKatashikiUpdatePayload を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function buildKatashikiUpdatePayload(
  katashikiParams: KatashikiParams
): any {
  const payload: any = {
    uketsukeExtendsId: katashikiParams.uketsukeExtendsId,
    katashikiShiteiNo: katashikiParams.katashikiShiteiNo,
    ruibetsuKubunNo: katashikiParams.ruibetsuKubunNo,
    nisseirenKatashiki: katashikiParams.nisseirenKatashiki,
    nisseirenEngineKatashiki: katashikiParams.nisseirenEngineKatashiki,
    junseiKatashiki: katashikiParams.junseiKatashiki,
    junseiEngineKatashiki: katashikiParams.junseiEngineKatashiki,
    syaryouShiki: katashikiParams.syaryouShiki,
    syaryouShuki: katashikiParams.syaryouShuki,
    modelCd: katashikiParams.modelCd,
    kakyukiKbn: katashikiParams.kakyukiKbn
  };
  if (katashikiParams.searchKatashiki !== undefined) {
    payload.searchKatashiki = katashikiParams.searchKatashiki;
  }
  if (katashikiParams.searchEngineKatashiki !== undefined) {
    payload.searchEngineKatashiki = katashikiParams.searchEngineKatashiki;
  }
  return payload;
}

/*
 * buildKatashikiParamsApplyState を WorkAndBuhin.vue から分離し、
 * 型式選択後に service、表示項目、API 更新へ反映する state と実行条件を親側置換や単体テストで固定するため。
 */
export function buildKatashikiParamsApplyState(
  params: any,
  uketsukeExtendsId: number
): KatashikiParamsApplyState {
  const katashikiParams = typeof params.nisseirenKatashiki === "object" &&
    typeof params.junseiKatashiki === "object"
    ? buildKatashikiParams(
      params.nisseirenKatashiki,
      params.junseiKatashiki,
      params.searchKatashiki || "",
      params.searchEngineKatashiki || "",
      uketsukeExtendsId
    )
    : buildKatashikiParamsFromSaved(params, uketsukeExtendsId);
  return {
    katashikiParams,
    hasKatashiki: true,
    shouldSetKatashikiParams: true,
    shouldUpdateDisplayFields: true,
    shouldUpdateKatashiki: true
  };
}

/*
 * buildKatashikiParamsApplyEffectState を WorkAndBuhin.vue から分離し、
 * 型式 params 反映後に実行する service 更新、表示更新、API 更新の副作用条件を親側置換や単体テストで固定するため。
 */
export function buildKatashikiParamsApplyEffectState(
  applyState: KatashikiParamsApplyState
): KatashikiParamsApplyEffectState {
  return {
    katashikiParams: applyState.katashikiParams,
    hasKatashiki: applyState.hasKatashiki,
    shouldSetKatashikiParams: applyState.shouldSetKatashikiParams,
    shouldUpdateDisplayFields: applyState.shouldUpdateDisplayFields,
    shouldUpdateKatashiki: applyState.shouldUpdateKatashiki
  };
}

/*
 * buildKatashikiSelectedActionState を WorkAndBuhin.vue から分離し、
 * 型式選択 dialog 確定後の型式反映と日整連・純正部品検索の実行順序を親側置換や単体テストで固定するため。
 */
export function buildKatashikiSelectedActionState(
  params: any
): KatashikiSelectedActionState {
  return {
    shouldSetKatashikiParams: true,
    katashikiParamsSource: params,
    shouldLoadNisseirenJunsei: true
  };
}

/*
 * buildKatashikiSelectedApplyEffectState を WorkAndBuhin.vue から分離し、
 * 型式選択確定後に component が呼ぶ型式反映と日整連・純正部品検索の副作用条件を親側置換や単体テストで固定するため。
 */
export function buildKatashikiSelectedApplyEffectState(
  actionState: KatashikiSelectedActionState
): KatashikiSelectedApplyEffectState {
  return {
    shouldSetKatashikiParams: actionState.shouldSetKatashikiParams,
    katashikiParamsSource: actionState.katashikiParamsSource,
    shouldLoadNisseirenJunsei: actionState.shouldLoadNisseirenJunsei
  };
}

/*
 * resolveKatashikiDialogOpenParams を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function resolveKatashikiDialogOpenParams(
  katashikiParams: Partial<KatashikiParams>,
  uketsukeExtendsId: number,
  fallbackKatashiki: string,
  fallbackEngineKatashiki: string
): KatashikiDialogOpenParams {
  if (
    katashikiParams.uketsukeExtendsId &&
    katashikiParams.uketsukeExtendsId === uketsukeExtendsId
  ) {
    return {
      katashiki: katashikiParams.nisseirenKatashiki || "",
      engineKatashiki: katashikiParams.nisseirenEngineKatashiki || ""
    };
  }
  return {
    katashiki: fallbackKatashiki || "",
    engineKatashiki: fallbackEngineKatashiki || ""
  };
}

/*
 * buildKatashikiDialogOpenActionState を WorkAndBuhin.vue から分離し、
 * 型式選択 dialog を開く条件と初期表示引数を親側置換や単体テストで固定するため。
 */
export function buildKatashikiDialogOpenActionState(params: {
  katashikiParams: Partial<KatashikiParams>;
  uketsukeExtendsId: number;
  fallbackKatashiki: string;
  fallbackEngineKatashiki: string;
}): KatashikiDialogOpenActionState {
  const dialogParams = resolveKatashikiDialogOpenParams(
    params.katashikiParams,
    params.uketsukeExtendsId,
    params.fallbackKatashiki,
    params.fallbackEngineKatashiki
  );
  return {
    shouldOpen: true,
    katashiki: dialogParams.katashiki,
    engineKatashiki: dialogParams.engineKatashiki
  };
}

/*
 * buildKatashikiDialogOpenApplyEffectState を WorkAndBuhin.vue から分離し、
 * 型式選択 dialog を開く副作用の実行可否と引数を親側置換や単体テストで固定するため。
 */
export function buildKatashikiDialogOpenApplyEffectState(
  actionState: KatashikiDialogOpenActionState
): KatashikiDialogOpenApplyEffectState {
  return {
    shouldOpen: actionState.shouldOpen,
    katashiki: actionState.katashiki,
    engineKatashiki: actionState.engineKatashiki
  };
}

/*
 * buildNisseirenJunseiSearchDialogOpenActionState を WorkAndBuhin.vue から分離し、
 * 日整連・純正部品検索 dialog を開く条件と引数を親側置換や単体テストで固定するため。
 */
export function buildNisseirenJunseiSearchDialogOpenActionState(
  isJunseiOnly: boolean,
  isUseJunseiBuhin: boolean
): NisseirenJunseiSearchDialogOpenActionState {
  return {
    shouldOpen: true,
    isJunseiOnly,
    isUseJunseiBuhin
  };
}

/*
 * buildNisseirenJunseiSearchDialogOpenApplyEffectState を WorkAndBuhin.vue から分離し、
 * 日整連・純正部品検索 dialog を開く副作用の実行可否と引数を親側置換や単体テストで固定するため。
 */
export function buildNisseirenJunseiSearchDialogOpenApplyEffectState(
  actionState: NisseirenJunseiSearchDialogOpenActionState
): NisseirenJunseiSearchDialogOpenApplyEffectState {
  return {
    shouldOpen: actionState.shouldOpen,
    isJunseiOnly: actionState.isJunseiOnly,
    isUseJunseiBuhin: actionState.isUseJunseiBuhin
  };
}

/*
 * shouldOpenKatashikiDialogForMissingParams を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function shouldOpenKatashikiDialogForMissingParams(params: {
  katashiki: string;
  engineKatashiki: string;
  isUseNisseiren: number;
}): boolean {
  return !!(
    (!params.katashiki || params.katashiki.length === 0) &&
    (!params.engineKatashiki || params.engineKatashiki.length === 0) &&
    params.isUseNisseiren
  );
}

/*
 * buildKatashikiSearchInitialActionState を WorkAndBuhin.vue から分離し、
 * 型式検索前に API 検索へ進むか、missing params dialog を開くかの条件を親側置換や単体テストで固定するため。
 */
export function buildKatashikiSearchInitialActionState(params: {
  katashiki: string;
  engineKatashiki: string;
  isUseNisseiren: number;
}): KatashikiSearchInitialActionState {
  const isMissingParams = (
    (!params.katashiki || params.katashiki.length === 0) &&
    (!params.engineKatashiki || params.engineKatashiki.length === 0)
  );
  if (!isMissingParams) {
    return {
      shouldRequestKatashikiList: true,
      shouldOpenDialog: false,
      dialogKatashiki: "",
      dialogEngineKatashiki: ""
    };
  }
  return {
    shouldRequestKatashikiList: false,
    shouldOpenDialog: shouldOpenKatashikiDialogForMissingParams(params),
    dialogKatashiki: "",
    dialogEngineKatashiki: ""
  };
}

/*
 * buildKatashikiSearchInitialApplyEffectState を WorkAndBuhin.vue から分離し、
 * 型式検索前に API 検索を止めて nextTick で dialog を開く副作用条件を親側置換や単体テストで固定するため。
 */
export function buildKatashikiSearchInitialApplyEffectState(
  actionState: KatashikiSearchInitialActionState
): KatashikiSearchInitialApplyEffectState {
  return {
    shouldRequestKatashikiList: actionState.shouldRequestKatashikiList,
    shouldOpenDialogOnNextTick: actionState.shouldOpenDialog,
    dialogKatashiki: actionState.dialogKatashiki,
    dialogEngineKatashiki: actionState.dialogEngineKatashiki
  };
}

/*
 * shouldAutoSetKatashikiSearchResult を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function shouldAutoSetKatashikiSearchResult(
  nisseirenKatashikiList: any[],
  junseiKatashikiList: any[]
): boolean {
  return nisseirenKatashikiList.length === 1 && junseiKatashikiList.length === 1;
}

/*
 * shouldOpenKatashikiDialogForSearchResult を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function shouldOpenKatashikiDialogForSearchResult(
  data: any[],
  isUseNisseiren: number
): boolean {
  return !!(data.length !== 1 && isUseNisseiren);
}

/*
 * shouldOpenKatashikiDialogForNoResult を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function shouldOpenKatashikiDialogForNoResult(
  err: any,
  isUseNisseiren: number
): boolean {
  return !!(err && err.status === 204 && isUseNisseiren);
}

/*
 * buildKatashikiSearchResultActionState を WorkAndBuhin.vue から分離し、
 * 型式検索結果から自動設定、dialog open、no-op の分岐を親側置換や単体テストで固定するため。
 */
export function buildKatashikiSearchResultActionState(params: {
  searchResult: any;
  isUseNisseiren: number;
  katashiki: string;
  engineKatashiki: string;
}): KatashikiSearchResultActionState {
  if (params.searchResult && params.searchResult.error) {
    return {
      shouldSetKatashikiParams: false,
      katashikiParamsSource: null,
      shouldOpenDialog: shouldOpenKatashikiDialogForNoResult(
        params.searchResult.error,
        params.isUseNisseiren
      ),
      dialogKatashiki: params.katashiki,
      dialogEngineKatashiki: params.engineKatashiki,
      dialogData: []
    };
  }
  const data = params.searchResult && params.searchResult.data
    ? params.searchResult.data
    : [];
  if (shouldAutoSetKatashikiSearchResult(data, data)) {
    return {
      shouldSetKatashikiParams: true,
      katashikiParamsSource: data[0],
      shouldOpenDialog: false,
      dialogKatashiki: "",
      dialogEngineKatashiki: "",
      dialogData: []
    };
  }
  return {
    shouldSetKatashikiParams: false,
    katashikiParamsSource: null,
    shouldOpenDialog: shouldOpenKatashikiDialogForSearchResult(
      data,
      params.isUseNisseiren
    ),
    dialogKatashiki: params.katashiki,
    dialogEngineKatashiki: params.engineKatashiki,
    dialogData: data
  };
}

/*
 * buildKatashikiSearchResultApplyEffectState を WorkAndBuhin.vue から分離し、
 * 型式検索結果後に component が実行する自動設定と dialog open の副作用条件を親側置換や単体テストで固定するため。
 */
export function buildKatashikiSearchResultApplyEffectState(
  actionState: KatashikiSearchResultActionState
): KatashikiSearchResultApplyEffectState {
  return {
    shouldSetKatashikiParams: actionState.shouldSetKatashikiParams,
    katashikiParamsSource: actionState.katashikiParamsSource,
    shouldOpenDialog: actionState.shouldOpenDialog,
    dialogKatashiki: actionState.dialogKatashiki,
    dialogEngineKatashiki: actionState.dialogEngineKatashiki,
    dialogData: actionState.dialogData
  };
}

/*
 * resolveShowKatashiki を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function resolveShowKatashiki(
  hasKatashiki: boolean,
  katashikiParams: Partial<KatashikiParams>,
  fallbackKatashiki: string
): string {
  if (hasKatashiki) {
    return katashikiParams.nisseirenKatashiki || "";
  }
  return fallbackKatashiki || "";
}

/*
 * resolveShowEngineKatashiki を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function resolveShowEngineKatashiki(
  hasKatashiki: boolean,
  katashikiParams: Partial<KatashikiParams>,
  fallbackEngineKatashiki: string
): string {
  if (hasKatashiki) {
    return katashikiParams.nisseirenEngineKatashiki || "";
  }
  return fallbackEngineKatashiki || "";
}

/*
 * resolveShowKakyuki を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function resolveShowKakyuki(
  hasKatashiki: boolean,
  katashikiParams: Partial<KatashikiParams>
): string {
  return hasKatashiki ? katashikiParams.kakyuki || "" : "";
}

/*
 * resolveShowModelNm を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function resolveShowModelNm(params: {
  hasKatashiki: boolean;
  katashikiParams: Partial<KatashikiParams>;
  currentState: any;
}): string {
  if (params.hasKatashiki) {
    return params.katashikiParams.modelNm || "";
  }
  if (params.currentState && params.currentState.uketsuke) {
    return params.currentState.uketsuke.srModelNm;
  }
  return "";
}

export interface KatashikiDisplayUpdateState {
  showKatashiki: string;
  showEngineKatashiki: string;
  showKakyuki: string;
  showModelNm: string;
}

export interface NisseirenWorkReadonlyState {
  isReadonly: boolean;
}

export interface WorkKouchinDisabledState {
  disabledValue: true | null;
}

export interface NisseirenWorkSearchButtonState {
  shouldShow: boolean;
  isDisabled: boolean;
}

export interface JunseiBuhinSearchButtonState {
  isDisabled: boolean;
}

export interface KatashikiButtonDisplayState {
  shouldShow: boolean;
}

/*
 * buildKatashikiDisplayUpdateState を WorkAndBuhin.vue から分離し、
 * 型式 params 変更時に画面へ表示する4項目の fallback 条件をまとめて固定するため。
 */
export function buildKatashikiDisplayUpdateState(params: {
  hasKatashiki: boolean;
  katashikiParams: Partial<KatashikiParams>;
  fallbackKatashiki: string;
  fallbackEngineKatashiki: string;
  currentState: any;
}): KatashikiDisplayUpdateState {
  return {
    showKatashiki: resolveShowKatashiki(
      params.hasKatashiki,
      params.katashikiParams,
      params.fallbackKatashiki
    ),
    showEngineKatashiki: resolveShowEngineKatashiki(
      params.hasKatashiki,
      params.katashikiParams,
      params.fallbackEngineKatashiki
    ),
    showKakyuki: resolveShowKakyuki(
      params.hasKatashiki,
      params.katashikiParams
    ),
    showModelNm: resolveShowModelNm({
      hasKatashiki: params.hasKatashiki,
      katashikiParams: params.katashikiParams,
      currentState: params.currentState
    })
  };
}

/*
 * isNisseirenWorkReadOnly を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function isNisseirenWorkReadOnly(work: any): boolean {
  if (work.sknNisseirenCd) {
    if ((work.kouchinZn) && work.kouchinZn === 0) {
      return true;
    }
    return false;
  }
  return false;
}

/*
 * buildNisseirenWorkReadonlyState を WorkAndBuhin.vue から分離し、
 * 工賃入力の readonly 条件である部品なし状態と日整連作業判定をまとめて固定するため。
 */
export function buildNisseirenWorkReadonlyState(params: {
  disabledBtnNoBuhin: boolean;
  work: any;
}): NisseirenWorkReadonlyState {
  return {
    isReadonly:
      params.disabledBtnNoBuhin || isNisseirenWorkReadOnly(params.work)
  };
}

/*
 * buildWorkKouchinDisabledState を WorkAndBuhin.vue から分離し、
 * 無償作業の工賃入力 disabled 条件と notFreeKouchin 例外の戻り値を固定するため。
 */
export function buildWorkKouchinDisabledState(params: {
  work: any;
  allowNotFreeKouchin: boolean;
}): WorkKouchinDisabledState {
  const isDisabled = params.work.isDiscount === 1 &&
    (!params.allowNotFreeKouchin || params.work.notFreeKouchin !== 1);
  return {
    disabledValue: isDisabled ? true : null
  };
}

/*
 * buildNisseirenWorkSearchButtonState を WorkAndBuhin.vue から分離し、
 * 日整連作業検索ボタンは、作業の無償設定に関係なく型式未選択時だけ無効にする。
 */
export function buildNisseirenWorkSearchButtonState(params: {
  isUseNisseiren: number | boolean;
  hideNisseirenJunsei: boolean;
  hasKatashiki: boolean;
  isDiscount: boolean;
}): NisseirenWorkSearchButtonState {
  return {
    shouldShow: !!params.isUseNisseiren && !params.hideNisseirenJunsei,
    isDisabled: !params.hasKatashiki
  };
}

/*
 * buildJunseiBuhinSearchButtonState を WorkAndBuhin.vue から分離し、
 * 純正部品検索ボタンを型式未選択時に disabled にする条件を固定するため。
 */
export function buildJunseiBuhinSearchButtonState(params: {
  hasKatashiki: boolean;
}): JunseiBuhinSearchButtonState {
  return {
    isDisabled: !params.hasKatashiki
  };
}

/*
 * buildKatashikiButtonDisplayState を WorkAndBuhin.vue から分離し、
 * 型式選択ボタンを日整連利用時だけ表示する条件を固定するため。
 */
export function buildKatashikiButtonDisplayState(params: {
  isUseNisseiren: number | boolean;
}): KatashikiButtonDisplayState {
  return {
    shouldShow: !!params.isUseNisseiren
  };
}

/*
 * buildJunseiTabState を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function buildJunseiTabState(
  listManualBuhin: BuhinDetail[],
  listSelectedBuhin: BuhinDetail[]
): JunseiTabState {
  const listManualBuhinFiltered = filterJunseiBuhin(listManualBuhin);
  let autoSelectBuhin: BuhinDetail | null = null;
  if (listManualBuhinFiltered.length === 1) {
    const buhin = listManualBuhinFiltered[0];
    const junseiIndex = findJunseiBuhinIndex(listSelectedBuhin, buhin);
    if (junseiIndex === -1 && buhin.quantity > 0) {
      autoSelectBuhin = buhin;
    }
  }
  return {
    activeBuhinCateIndex: -4,
    activeCateBuhins: [],
    activeBuhinShubetsuId: 0,
    buhinContent: [],
    listManualBuhinFiltered,
    autoSelectBuhin
  };
}

/*
 * buildJunseiTabApplyEffectState を WorkAndBuhin.vue から分離し、
 * 純正部品タブ選択後に component へ反映する state と自動選択条件を固定するため。
 */
export function buildJunseiTabApplyEffectState(
  tabState: JunseiTabState
): JunseiTabApplyEffectState {
  return {
    activeBuhinCateIndex: tabState.activeBuhinCateIndex,
    activeCateBuhins: tabState.activeCateBuhins,
    activeBuhinShubetsuId: tabState.activeBuhinShubetsuId,
    buhinContent: tabState.buhinContent,
    listManualBuhinFiltered: tabState.listManualBuhinFiltered,
    shouldApplyBuhinContent: true,
    shouldApplyManualBuhinFiltered: true,
    shouldAutoSelectBuhin: !!tabState.autoSelectBuhin,
    autoSelectBuhin: tabState.autoSelectBuhin
  };
}

/*
 * filterJunseiBuhin を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function filterJunseiBuhin(listManualBuhin: BuhinDetail[]): BuhinDetail[] {
  const listJunseiBuhin: BuhinDetail[] = [];
  if (listManualBuhin.length > 0) {
    listManualBuhin.forEach((buhin: BuhinDetail) => {
      if (isJunseiBuhinCode(buhin.buhinCd)) {
        listJunseiBuhin.push(buhin);
      }
    });
  }
  return listJunseiBuhin;
}

/*
 * shouldSelectSingleAddedNisseirenWork を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function shouldSelectSingleAddedNisseirenWork(
  manualSeibiList: Work[] | null | undefined,
  filteredNisseirenWork: any[]
): boolean {
  return !!(
    manualSeibiList &&
    manualSeibiList.length > 0 &&
    filteredNisseirenWork.length === 1
  );
}

/*
 * getLastManualWorkSelectionState を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function getLastManualWorkSelectionState(
  manualSeibiList: Work[] | null | undefined
): ManualWorkSelectionState | null {
  if (!manualSeibiList || manualSeibiList.length === 0) {
    return null;
  }
  const activeWorkIndex = manualSeibiList.length - 1;
  const work = manualSeibiList[activeWorkIndex];
  return {
    isManualWork: true,
    activeWorkIndex,
    activeSeibiId: work.seibiDetailId,
    activeSeibiNm: work.seibiNm,
    work
  };
}

/*
 * shouldApplySelectedJunseiBuhin を WorkAndBuhin.vue から分離し、
 * 型式・日整連・純正検索 を親側置換や単体テストで固定するため。
 */
export function shouldApplySelectedJunseiBuhin(
  activeWorkIndex: number,
  filteredJunseiBuhin: any[]
): boolean {
  return activeWorkIndex > -1 && filteredJunseiBuhin.length > 0;
}

/*
 * buildNisseirenJunseiSelectedActionState を WorkAndBuhin.vue から分離し、
 * 日整連・純正部品検索結果の選択反映順序と実行条件を親側置換や単体テストで固定するため。
 */
export function buildNisseirenJunseiSelectedActionState(params: {
  manualSeibiList: Work[] | null | undefined;
  filteredNisseirenWork: any[];
  filteredJunseiBuhin: any[];
  isUseJunseiBuhin: boolean;
  activeWorkIndex: number;
}): NisseirenJunseiSelectedActionState {
  const shouldSelectManualWork = shouldSelectSingleAddedNisseirenWork(
    params.manualSeibiList,
    params.filteredNisseirenWork
  );
  const manualWorkSelectionState = shouldSelectManualWork
    ? getLastManualWorkSelectionState(params.manualSeibiList)
    : null;
  const effectiveActiveWorkIndex = manualWorkSelectionState
    ? manualWorkSelectionState.activeWorkIndex
    : params.activeWorkIndex;

  return {
    shouldSelectManualWork: !!manualWorkSelectionState,
    manualWorkSelectionState,
    shouldUseJunseiBuhin: params.isUseJunseiBuhin,
    shouldSetFoundJunseiBuhin: params.isUseJunseiBuhin,
    shouldApplySelectedJunseiBuhin: params.isUseJunseiBuhin &&
      shouldApplySelectedJunseiBuhin(
        effectiveActiveWorkIndex,
        params.filteredJunseiBuhin
      ),
    shouldSelectJunseiTab: params.isUseJunseiBuhin
  };
}

/*
 * buildNisseirenJunseiSelectedApplyEffectState を WorkAndBuhin.vue から分離し、
 * 日整連・純正部品検索 dialog の選択結果を作業・部品・scroll・tab へ反映する副作用条件を固定するため。
 */
export function buildNisseirenJunseiSelectedApplyEffectState(params: {
  actionState: NisseirenJunseiSelectedActionState;
  filteredNisseirenWork: any[];
  filteredJunseiBuhin: any[];
}): NisseirenJunseiSelectedApplyEffectState {
  const shouldApplySelectedJunsei = params.actionState.shouldApplySelectedJunseiBuhin;
  return {
    shouldSetFoundNisseirenWork: true,
    foundNisseirenWork: params.filteredNisseirenWork,
    shouldSelectManualWork: params.actionState.shouldSelectManualWork,
    manualWorkSelectionState: params.actionState.manualWorkSelectionState,
    shouldScrollManualWork: params.actionState.shouldSelectManualWork,
    manualWorkScrollTargetId: "list-work",
    shouldUseJunseiBuhin: params.actionState.shouldUseJunseiBuhin,
    shouldSetFoundJunseiBuhin: params.actionState.shouldSetFoundJunseiBuhin,
    foundJunseiBuhin: params.filteredJunseiBuhin,
    shouldApplySelectedJunseiBuhin: shouldApplySelectedJunsei,
    shouldSetWorkBuhinSelectedDone: shouldApplySelectedJunsei,
    shouldSetIsChange: shouldApplySelectedJunsei,
    isChange: true,
    shouldAppendSelectedJunseiBuhin: shouldApplySelectedJunsei,
    selectedJunseiBuhinToAppend: params.filteredJunseiBuhin,
    shouldScrollJunseiBuhin: shouldApplySelectedJunsei,
    junseiBuhinScrollTargetId: "list-buhin",
    shouldCheckDisabledBtnConfirm: shouldApplySelectedJunsei,
    shouldSelectJunseiTab: params.actionState.shouldSelectJunseiTab
  };
}
